import React, { Component, Fragment } from "react";
import { Link ,  NavLink , withRouter } from "react-router-dom";
import AppContext from "../../contexts/AppContext";
import HeaderNotifications from "../notifications/HeaderNotifications";
import Connect from "./connects/Connect";
import Alart from "./Alert";
import HeaderMessages from "../messages/HeaderMessages";

export class Header extends Component {
    render() {
        return (
            <Fragment>
                <nav className="navbar navbar-expand-lg fixed-top navbar-light py-2">
                    <div className="container-fluid px-5">
                        <NavLink
                            activeClassName='active'
                            className="navbar-brand d-lg-none d-sm-block"
                            to={`/`}
                        >
                            <img
                                src={this.context.state.user.image}
                                className="navbar-brand-img mx-auto"
                                alt=""
                            />
                        </NavLink>
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>

                        <div
                            className="collapse mx-md-auto navbar-collapse nav-container collapsed-logo w-100"
                            id="navbarSupportedContent"
                        >
                            <div className="navbar-left">
                                <ul className="navbar-nav">
                                    <li className="nav-item">
                                        <NavLink
                                            activeClassName='active'
                                            className="nav-link"
                                            to={`/writer/dashboard`}
                                            aria-controls="sidebarDashboards"
                                        >
                                            Dashboard
                                        </NavLink>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a
                                            className="nav-link"
                                            id="jobsMenu"
                                            data-toggle="dropdown"
                                            role="button"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            aria-controls="jobsMenu"
                                        >
                                            Portfolio
                                        </a>
                                        <div
                                            className="dropdown-menu hide"
                                            aria-labelledby="Products"
                                        >
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <NavLink
                                                        activeClassName='active'
                                                        className="nav-link "
                                                        to={`/pw/${this.context.state.user.url}`}
                                                        target="_blank"
                                                    >
                                                        View portfolio{" "}
                                                        <i className="fe fe-external-link"></i>
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink
                                                        activeClassName='active'
                                                        to={`/writer/badges`}
                                                        className="nav-link"
                                                    >
                                                        My badges
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink
                                                        activeClassName='active'
                                                        className="nav-link"
                                                        to={`/writer/profile/settings`}
                                                    >
                                                        Manage portfolio
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink
                                                        activeClassName='active'
                                                        className="nav-link"
                                                        to={`/writer/visitors`}
                                                    >
                                                        Portfolio visitors
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <a
                                            className="nav-link"
                                            id="Databases"
                                            data-toggle="dropdown"
                                            role="button"
                                        >
                                            Find jobs
                                        </a>
                                        <div
                                            className="dropdown-menu hide"
                                            aria-labelledby="Products"
                                        >
                                            <ul className="nav nav-sm flex-column">
                                                <li className="nav-item">
                                                    <a
                                                        className="nav-link "
                                                        href="/jobs"
                                                        target="_blank"
                                                    >
                                                        Jobs board{" "}
                                                        <i className="fe fe-external-link"></i>
                                                    </a>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink
                                                        to={`/writer/savedJobs`}
                                                        className="nav-link"
                                                    >
                                                        Saved jobs
                                                    </NavLink>
                                                </li>
                                                <li className="nav-item">
                                                    <NavLink
                                                        className="nav-link"
                                                        to={`/writer/applications`}
                                                    >
                                                        Applications
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    </li>

                                    <li className="nav-item dropdown">
                                        <NavLink
                                            className="nav-link"
                                            role="button"
                                            aria-controls="Accounting"
                                            to={`/writer/clients`}
                                        >
                                            My clients
                                        </NavLink>
                                    </li>
                                </ul>{" "}
                            </div>
                            <div className="navbar-center">
                                <img src="/images/logo_dark.png" alt="Logo" width="30" height="46" />
                            </div>
                            <div className="navbar-right d-flex ml-auto ">
                                <div className="header-icons align-middle ">
                                    {this.context.state.user.state ===
                                    "approved"
                                        ? null // <Connect></Connect>
                                        : null}
                                    <HeaderNotifications></HeaderNotifications>
                                    <HeaderMessages></HeaderMessages>
                                </div>

                                <div className="navbar-user  ">
                                    <div className="dropdown">
                                        <NavLink
                                            to={`/writer/dashboard`}
                                            id="sidebarIcon"
                                            className="dropdown-t nav-link dropdown-toggler-user"
                                            role="button"
                                        >
                                            <div className="avatar avatar-sm avatar-online">
                                                <img
                                                    src={
                                                        this.context.state.user
                                                            .image
                                                    }
                                                    className="avatar-img user-avatar-img rounded-circle"
                                                    alt=""
                                                />
                                            </div>
                                        </NavLink>

                                        <div
                                            className="dropdown-menu dropdown-menu-right hide"
                                            aria-labelledby="sidebarIcon"
                                        >
                                            <div className="username">
                                                {
                                                    this.context.state.user
                                                        .first_name
                                                }{" "}
                                                {
                                                    this.context.state.user
                                                        .last_name
                                                }
                                            </div>
                                            <hr />

                                            {/* <NavLink
                                                className="dropdown-item"
                                                to={`/writer/profile/settings`}
                                            >
                                                Settings
                                            </NavLink> */}
                                            <NavLink
                                                className="dropdown-item"
                                                to={`/writer/account/settings`}
                                            >
                                                Settings
                                            </NavLink>
                                            <NavLink
                                                className="dropdown-item"
                                                to={`/writer/billing`}
                                            >
                                                Billing
                                            </NavLink>
                                            <a
                                                className="dropdown-item"
                                                target="_blank"
                                                href="http://faq.prowriter.co/"
                                                rel="noopener noreferrer"
                                            >
                                                Help Center{" "}
                                                <i className="fe fe-external-link"></i>
                                            </a>
                                            <hr className="dropdown-divider" />
                                            <NavLink
                                                to={`/logout`}
                                                className="dropdown-item"
                                            >
                                                Logout
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
                <Alart></Alart>
            </Fragment>
        );
    }
}
Header.contextType = AppContext;

export default withRouter(({ location, ...props }) => {
    return <Header {...props}   />;
 });



// WEBPACK FOOTER //
// ./src/components/writer/Header.js